import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Heading6: FC<TextProps> = props => (
  <Text
    as="h6"
    fontSize="legal"
    fontWeight="bold"
    {...props}
    className={classNames(props.className, 'text_heading6')}
  />
);

export default Heading6;
